import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import DashboardOverview from './pages/dashboard-overview';
import BrandingCostCalculator from './pages/branding-cost-calculator';
import BrandAnalytics from './pages/brand-analytics';
import BrandingAndBrandingMaterialTracker from './pages/installation-tracking';
import StoreManagement from './pages/store-management';
import KeyVisualManagement from './pages/key-visual-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<DashboardOverview />} />
        <Route path="/dashboard-overview" element={<DashboardOverview />} />
        <Route path="/branding-cost-calculator" element={<BrandingCostCalculator />} />
        <Route path="/brand-analytics" element={<BrandAnalytics />} />
        <Route path="/installation-tracking" element={<BrandingAndBrandingMaterialTracker />} />
        <Route path="/branding-material-tracker" element={<BrandingAndBrandingMaterialTracker />} />
        <Route path="/store-management" element={<StoreManagement />} />
        <Route path="/kv" element={<KeyVisualManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;